import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, Typography } from '@mui/material';
import TabPanel from '../../../../components/TabPanel';

const SEASONS = [
  { id: 'low', i18n: 'tickets_service.seasons.low' },
  { id: 'regular', i18n: 'tickets_service.seasons.regular' },
  { id: 'high', i18n: 'tickets_service.seasons.high' },
];

export interface TicketCardProps {
  title: string;
  content: string;
  highSeason: string;
  lowSeason: string;
  stdSeason: string;
  backgroundIcon: string;
  typeColor: string;
  alt: string;
}

export const TicketCard = ({
  title,
  content,
  highSeason,
  lowSeason,
  stdSeason,
  backgroundIcon,
  alt,
}: TicketCardProps) => {
  const { t } = useTranslation();

  const [selectedSeason, setSelectedSeason] = useState(0);

  return (
    <Stack
      flexDirection={{ xs: 'column-reverse', md: 'row' }}
      alignItems="center"
      gap={{ xs: 4, md: 10 }}
      className="container"
      borderRadius={2}
      padding="2em"
      py={6}
    >
      <img
        src={backgroundIcon}
        alt={alt}
        style={{
          width: '100%',
          maxWidth: '420px',
          height: '430px',
          borderRadius: '12px',
          alignSelf: 'center',
          display: 'flex',
          objectFit: 'cover'
        }}
      />

      <Stack width="100%" px={{ xs: 2, md: 0 }}>
        <Typography color="primary.main" fontSize={32} fontWeight={700} mb={2.5}>
          {title}
        </Typography>
        <Box
          sx={{ '& ul': { listStyle: 'none', '& li': { marginBottom: 2.5 } } }}
          dangerouslySetInnerHTML={{ __html: content }}
        />
        <Stack
          flexDirection="row"
          flexWrap={{ xs: 'nowrap', sm: 'wrap' }}
          gap={1.5}
          overflow="auto"
          sx={{ '&::-webkit-scrollbar': { opacity: 0 } }}
        >
          {SEASONS.map(({ id, i18n }, index) => {
            const isSelected = selectedSeason === index;

            return (
              <Button
                key={id}
                sx={{
                  '&.MuiButton-root': {
                    bgcolor: isSelected ? '#3F2B56' : '#E8E8E8',
                    color: isSelected ? '#FFFFFF' : '#333334',
                    fontWeight: isSelected ? 500 : 400,
                    minWidth: 'fit-content',
                    height: 32,
                    paddingX: 3,
                    borderRadius: 8,
                    textWrap: 'nowrap',

                    '&:hover, &:focus': {
                      bgcolor: isSelected ? '#3F2B56' : '#E8E8E8',
                      color: isSelected ? '#FFFFFF' : '#333334',
                      borderBottom: 'none',
                    },
                  },
                }}
                onClick={() => setSelectedSeason(index)}
              >
                {t(i18n)}
              </Button>
            );
          })}
        </Stack>

        <TabPanel value={selectedSeason} index={0}>
          <Box dangerouslySetInnerHTML={{ __html: lowSeason }} />
        </TabPanel>
        <TabPanel value={selectedSeason} index={1}>
          <Box dangerouslySetInnerHTML={{ __html: stdSeason }} />
        </TabPanel>
        <TabPanel value={selectedSeason} index={2}>
          <Box dangerouslySetInnerHTML={{ __html: highSeason }} />
        </TabPanel>
      </Stack>
    </Stack>
  );
};
